@import "../../global/visualization-base.scss";

:host {
  --uui-box-plot-line: var(--uui-gray-01);
  --uui-box-plot-legend-box: var(--uui-gray-04);
  --uui-box-plot-axis-line: var(--uui-gray-05);
  --uui-box-plot-custom-pointer: var(--uui-white);

  @include chart-host;
}

.chart {
    @include bar-charts;

    &__axis {
        path {
            stroke: var(--uui-box-plot-axis-line);
            stroke-width: 1;
        }
    }

    &__line {
        stroke-width: 1;
        stroke: var(--uui-box-plot-line);
        fill: none;

        &--dashed {
            stroke-dasharray: 7 2;
        }
    }

    &__custom-point {
        fill: var(--uui-box-plot-custom-pointer);
        stroke: var(--uui-box-plot-line);
        stroke-width: 1;
        stroke-dasharray: 6 2;
    }

    &__legend {
        &-text {
            margin-top: 2px;
            margin-left: 4px;
        }

        &-row-item {
            margin-right: 20px;
            height: 14px;
        }

        &-line {
            stroke: var(--uui-box-plot-line);
            stroke-width: 1;
        }

        &-median-line {
            border-left: 1px dashed var(--uui-box-plot-line);
            height: 20px;
        }
    }

    &__tooltip {
        @include tooltip;

        &-row {
            margin-bottom: 5px;
        }

        div:last-child {
            margin-bottom: 0px !important; //override bottom margin from uui-dv-legend-label to center align
        }
    }

    &--hidden {
        display: none;
    }
}
